import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function formatPrice(price: number) {
  return new Intl.NumberFormat("en-GB", {
    style: "currency",
    currency: "GBP",
  }).format(price);
}

export const conditionLabels: Record<string, string> = {
  new: "New",
  "like-new": "Like New",
  "very-good": "Very Good",
  good: "Good",
  acceptable: "Acceptable",
};
